import { GET_TrayLocation_LIST_Register } from "../../../../constants/ActionTypes";
import { zeroPad } from "../../../../util/DaFrameword";


const InitialValue={
   TrayLocationList:[]
}

function TrayLocationRegister(state=InitialValue,action){

    switch (action.type) {
        case GET_TrayLocation_LIST_Register:
            return {
                ...state,
                    TrayLocationList:action.payload.map(x=>({
                    Id:zeroPad(x.id,8),
                    description:x.description,
                    active:x.active                
                })) 
            }
        default:
           return state
    }  

}

export default TrayLocationRegister;